const isMenuOpen = state => state.menuOpen;

const isNotificationCenterOpen = state => state.notificationCenterOpen;

function getNotifications(state) {
  return {
    ...state.notifications,
    unreadMatchesAndRequests:
      state.notifications.unreadMessages +
      state.notifications.unreadAndUpdatedMatches
  };
}

// undefined = no balance (freemium/trial or not fetched yet), 0 = used up.
const superLikesRemaining = state => state.superLikesRemaining;

function getAttentionDot(state) {
  return state.showAttentionDot;
}

function tabBarVisible(state) {
  return state.showMobileTabBar;
}

function stickyTabBar(state) {
  return state.stickyTabBar;
}

export default {
  isMenuOpen,
  isNotificationCenterOpen,
  getNotifications,
  superLikesRemaining,
  getAttentionDot,
  tabBarVisible,
  stickyTabBar
};
